import { render, staticRenderFns } from "./SupervisorInspectionForm.vue?vue&type=template&id=1c254bae&scoped=true&"
import script from "./SupervisorInspectionForm.vue?vue&type=script&lang=ts&"
export * from "./SupervisorInspectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisorInspectionForm.vue?vue&type=style&index=0&id=1c254bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c254bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VExpansionPanels,VProgressCircular,VRow})
